import { useSignal } from '@preact/signals'
import { clsx } from 'clsx'

import { Typography, TextLink } from 'components/UI'

import { emailState } from './state'
import { CountdownText, ReSendTimerButton } from './components'

type Props = {
	restartLogin: () => void
	buttonLoading: boolean
	handleSignIn: (e: Event) => Promise<void>
}

export const SuccessEmailSent = ({
	restartLogin,
	buttonLoading,
	handleSignIn
}: Props) => {
	const displayState = useSignal<'initial' | 'countdown' | 'recommendations'>(
		'initial'
	)
	const showRecommendationsList = useSignal(false)

	return (
		<div class='flex w-[30rem] flex-col items-center rounded-lg border border-black-600 p-8 pb-12'>
			<Typography
				class='text-center'
				color='text-product'
				text='Email sent'
				variant='h2'
			/>
			<div class='mt-6 text-center'>
				<Typography
					class='inline-block'
					color='text-white'
					text={
						displayState.value === 'initial'
							? 'An email has been sent to'
							: 'A new email has been sent to'
					}
					variant='text2'
				/>
				<Typography
					class='ml-1 mr-1 inline-block'
					color='text-product'
					text={emailState.value}
					variant='text2'
					weight='font-bold'
				/>
				<Typography
					class='inline-block'
					color='text-white'
					text='with the steps to complete the sign-in process.'
					variant='text2'
				/>

				{displayState.value === 'initial' && (
					<div class='mt-6 flex justify-center'>
						<ReSendTimerButton
							isLoading={buttonLoading}
							onReSendClick={async e => {
								await handleSignIn(e)
								displayState.value = 'countdown'
							}}
						/>
					</div>
				)}

				{displayState.value === 'countdown' && (
					<CountdownText
						onDisplayRecommendations={() => {
							displayState.value = 'recommendations'
						}}
					/>
				)}

				{displayState.value === 'recommendations' && (
					<>
						<TextLink
							ariaLabel="Didn't receive an email?"
							className={clsx('mt-5', {
								'mb-5': showRecommendationsList.value
							})}
							onClick={() => {
								showRecommendationsList.value = !showRecommendationsList.value
							}}
							text="Didn't receive an email?"
							variant='secondary'
						/>

						{showRecommendationsList.value && (
							<ul class='ml-16 list-disc text-start'>
								<li>
									<Typography
										color='text-black-200'
										text='Confirm you entered the correct email address.'
										variant='text3'
									/>
								</li>
								<li>
									<Typography
										color='text-black-200'
										text='Check your spam folder.'
										variant='text3'
									/>
								</li>
								<li>
									<TextLink
										ariaLabel='Sign-in with another method'
										onClick={restartLogin}
										size='small'
										text='Sign-in with another method.'
										variant='secondary'
									/>
								</li>
							</ul>
						)}
					</>
				)}
			</div>
		</div>
	)
}
